import React from "react";
import PropTypes from "prop-types";
import SVG from "theme/components/icons/base/SVG";

const ReviewFull = ({ fill, stroke, ...props }) => (
    <SVG fill="none" {...props}>
        <path
            d="M10.307 10.1922c0 1.8273-1.48066 3.3083-3.30673 3.3083-1.82606 0-3.30673-1.481-3.30673-3.3083 0-1.82731 1.48067-3.30829 3.30673-3.30829 1.82607 0 3.30673 1.48098 3.30673 3.30829ZM2.95808 5.05004c.70669.82542.6278 1.77169.17301 2.16138-.45458.3895-1.40101.32228-2.10768-.50313-.70669-.82543-.6278-1.77169-.173-2.16138.45457-.38951 1.40099-.32229 2.10767.50313Zm10.18862-.50243c.4548.38969.5337 1.33595-.173 2.16138-.7067.82541-1.6531.89263-2.1077.50313-.4548-.38969-.5337-1.33596.173-2.16139.7067-.82541 1.6531-.89263 2.1077-.50312Zm-7.0586-2.5534c.13911.53198.10075 1.03602-.04993 1.41506-.15078.37931-.39596.60064-.66474.67098-.26876.07034-.59079-.00252-.90786-.25931-.31685-.25663-.59701-.67726-.73612-1.20925-.13911-.53198-.10074-1.03602.04993-1.41506.15079-.37931.39597-.60064.66475-.67099.26876-.07033.59078.00253.90785.25932.31686.25663.59702.67726.73612 1.20925ZM9.55702.52618c.26879.07035.51398.29167.66478.67099.1506.37904.189.88307.0499 1.41506-.1391.53198-.41927.95262-.73612 1.20924-.31707.2568-.6391.32966-.90785.25932-.26879-.07034-.51397-.29167-.66475-.67098-.15068-.37904-.18904-.88308-.04993-1.41506.13911-.53199.41926-.95262.73612-1.20925.31707-.2568.63909-.32965.90785-.25932Z"
            fill={fill}
            stroke={stroke}
        />
    </SVG>
);

ReviewFull.propTypes = {
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    fill: PropTypes.string,
    stroke: PropTypes.string,
};

ReviewFull.defaultProps = {
    height: "14px",
    viewBox: "0 0 14 14",
    width: "14px",
    fill: "#004342",
    stroke: "#004342",
};

export default ReviewFull;
